import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import ServerSideCarousel from '../../../../commonComponents/carousel/ServerSideCarousel';
import CourseProp from '../../../academy/propTypes/courseProp';
import AcademyEnrolledCourse from '../../../academy/list/AcademyEnrolledCourse';

function CoursesSection({ t, myCourses }) {
  const carouselItems = items => {
    const sortedItems = items.sort((a, b) => b.highlight - a.highlight);
    return (
      sortedItems.map(course => (
        <div className="dash-courses">
          <AcademyEnrolledCourse
            key={course._id}
            course={course}
            highlight={course.highlight}
            isDashboard
          />
        </div>
      ))
    );
  };
  return (
    <div className="row">
      <div className="col-lg-12 col-12">
        <div className="">
          <div className="m-portlet__head">
            <div className="m-portlet__head-caption">
              <div className="m-portlet__head-title my-courses-title">
                <h3 className="m-portlet__head-text">{t('inbox_myCourses')}</h3>
              </div>
            </div>
          </div>
          <div className="m-portlet__body course-container">
            <ServerSideCarousel
              id="my-course-carousel"
              fetchUrl="/academy/enrolled"
              defaultFetchError="error_fetchCourses"
              items={myCourses}
            >
              {items =>
                carouselItems(items)
              }
            </ServerSideCarousel>
          </div>
        </div>
      </div>
    </div>
  );
}

CoursesSection.propTypes = {
  t: PropTypes.func.isRequired,
  myCourses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)).isRequired,
};

export default translate(CoursesSection);
